export function enumValues<const T extends Record<string, number>>(codes: T) {
  return Object.keys(codes) as [
    Extract<keyof T, string>,
    ...Array<Extract<keyof T, string>>,
  ]
}
